<template>
  <v-container fluid class="table-filter px-3">
    <v-row
      :style="[
        this.export.length >= 0
          ? { background: '#fff', padding: '2px' }
          : { background: 'none' },
      ]"
    >
      <v-col cols="12" sm="12" md="12" lg="9">
        <v-row class="justify-left">
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('status')"
          >
            <StatusAutoComplete
              v-model="filter.status"
              :clear="clearFilter"
            ></StatusAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="
              hasFilter('shop') ||
              filterDatas.expenseFor == 'shop' ||
              filterDatas.incomeFor == 'shop'
            "
          >
            <ShopAutoComplete
              v-model="filter.shop"
              :clear="clearFilter"
              :DefaultShopVisble="ShopVisible"
            ></ShopAutoComplete>
          </v-col>
          <!-- :lg="filter.end != '' ? 3 : 2" -->
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('dateRange')"
          >
            <DateRangeFilter
              :clear="clearFilter"
              @start="startChange"
              @clearFilters="clearFilterDates"
              @end="endChange"
            ></DateRangeFilter>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('dateRangebook')"
          >
            <DateRangeFilter
              :clear="clearFilter"
              @start="startChangeDateBook"
              @clearFilters="clearFilterDates"
              @end="endChange"
            ></DateRangeFilter>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('datepicker')"
          >
            <DatePicker
              :clear="clearFilter"
              :labelname="'Date'"
              v-model="filter.date"
            ></DatePicker>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('brand')"
          >
            <BrandAutoComplete
              v-model="filter.brand"
              :clear="clearFilter"
            ></BrandAutoComplete>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('ledgertype')"
          >
            <LedgerAutoComplete
              v-model="filter.ledger"
              :clear="clearFilter"
            ></LedgerAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('category')"
          >
            <CategoryAutoComplete
              v-model="filter.category"
              :clear="clearFilter"
            ></CategoryAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('bank')"
          >
            <BankAutoComplete
              v-model="filter.bank"
              :clear="clearFilter"
            ></BankAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('backbutton')"
          >
            <v-btn @click="clickedBackButton">
              <v-icon>mdi-keyboard-backspace</v-icon>Back</v-btn
            >
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('supplier')"
          >
            <SupplierAutoComplete
              v-model="filter.supplier"
              :clear="clearFilter"
            ></SupplierAutoComplete>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('customer')"
          >
            <CustomerAutoComplete
              v-model="filter.customer"
              :clear="clearFilter"
            ></CustomerAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('expenseCategory')"
          >
            <ExpenseCategoryAutoComplete
              v-model="filter.expenseCategory"
              :clear="clearFilter"
            ></ExpenseCategoryAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('incomeCategory')"
          >
            <IncomeCategoryAutoComplete
              v-model="filter.expenseCategory"
              :clear="clearFilter"
            ></IncomeCategoryAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('biller')"
          >
            <BillerAutoComplete
              v-model="filter.biller"
              :clear="clearFilter"
            ></BillerAutoComplete>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('product')"
          >
            <ProductAutoCompleteComponent
              v-model="filter.product"
              :clear="clearFilter"
            ></ProductAutoCompleteComponent>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="
              hasFilter('warehouse') ||
              filterDatas.expenseFor == 'warehouse' ||
              filterDatas.incomeFor == 'warehouse'
            "
          >
            <WareHouseAutoComplete
              v-model="filter.warehouse"
              :clear="clearFilter"
            ></WareHouseAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('customerType')"
          >
            <CustomerTypeAutoComplete
              v-model="filter.customerType"
              :clear="clearFilter"
            ></CustomerTypeAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('customerGroup')"
          >
            <v-select
              hide-details="auto"
              :items="CustomerGroups"
              :loading="loading"
              v-model="filter.customerGroup"
              item-text="name"
              item-value="id"
              label="Group"
              outlined
              clearable
              dense
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('paymentType')"
          >
            <PaymentTypeAutoComplete
              v-model="filter.paymenType"
              :clear="clearFilter"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('cash_book_for')"
          >
            <v-select
              hide-details="auto"
              :items="cash_book_for"
              :loading="loading"
              v-model="filter.cash_book_for"
              item-text="name"
              item-value="id"
              label="Cash Book For"
              outlined
              clearable
              dense
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('paymentStatus')"
          >
            <v-select
              hide-details="auto"
              :items="PaymentStatus"
              :loading="loading"
              v-model="filter.paymentStatus"
              item-text="name"
              item-value="id"
              label="Payment Status"
              outlined
              clearable
              dense
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('payment')"
          >
            <PaymentStatusAutoComplete
              v-model="filter.paymentStatus"
              :clear="clearFilter"
            ></PaymentStatusAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('purchaseStatus')"
          >
            <PurchaseStatusAutoComplete
              v-model="filter.purchaseStatus"
              :clear="clearFilter"
            ></PurchaseStatusAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('transferStatus')"
          >
            <TransferStatusAutoComplete
              v-model="filter.transferStatus"
              :clear="clearFilter"
            ></TransferStatusAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('cheqStatus')"
          >
            <ChequeStatusAutoComplete
              v-model="filter.cheqStatus"
              :clear="clearFilter"
            ></ChequeStatusAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('cheqFor')"
          >
            <ChequeForAutoComplete
              v-model="filter.cheqFor"
              :clear="clearFilter"
            ></ChequeForAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('saleType')"
          >
            <SaleTypeAutoComplete
              v-model="filter.saleType"
              :clear="clearFilter"
            ></SaleTypeAutoComplete>
            <!-- <v-autocomplete
              hide-details="auto"
              :items="SaleTypes"
              :loading="loading"
              v-model="filterDatas.saleType"
              item-text="name"
              item-value="id"
              label=" Sale Type"
              outlined
               @change="emitSalesTypeInput(filterDatas.saleType)"
              clearable
              dense
            ></v-autocomplete> -->
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('purchaseOrderStatus')"
          >
            <PurchaseOrderStatusAutoComplete
              v-model="filter.purchaseOrderStatus"
              :clear="clearFilter"
            ></PurchaseOrderStatusAutoComplete>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('type')"
          >
            <PaymentFormAutoComplete v-model="filter.type" :clear="clearFilter">
            </PaymentFormAutoComplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('expenseFor')"
          >
            <ExpenseFormForAutocomplete
              v-model="filter.expenseFor"
              :clear="clearFilter"
            >
            </ExpenseFormForAutocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('incomeFor')"
          >
            <IncomeFormForAutocomplete
              v-model="filter.incomeFor"
              :clear="clearFilter"
            >
            </IncomeFormForAutocomplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('toShop')"
          >
            <ToShopFilterAutocomplete
              v-model="filter.toShop"
              :clear="clearFilter"
            >
            </ToShopFilterAutocomplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('fromShop')"
          >
            <FromShopFilterAutocomplete
              v-model="filter.fromShop"
              :clear="clearFilter"
            >
            </FromShopFilterAutocomplete>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('damage')"
          >
            <DamageFilter
              v-model="filter.damage"
              :clear="clearFilter"
            ></DamageFilter>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('stock')"
          >
            <stock-count-filter
              v-model="filter.stock"
              :clear="clearFilter"
            ></stock-count-filter>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('total')"
          >
            <TotalFilter
              v-model="filter.amount"
              :clear="clearFilter"
            ></TotalFilter>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="12"
            class="px-3 py-1"
            v-if="hasFilter('dateRange1')"
          >
            <v-row style="color: #af3f0afa">
              <!-- date range card -->
              <v-col cols="12" lg="8" xl="8" md="12" sm="12" xs="12">
                <v-card
                  height="30px"
                  style="background-color: #005985; font-size: smaller"
                  v-if="filter.startDate && filter.end"
                >
                  <v-row style="color: white">
                    <v-col
                      cols="8"
                      lg="7"
                      sm="8"
                      md="7"
                      class="text-lg-left font-weight-bold ml-2"
                      style="margin-top: -12px"
                    >
                      FDR
                      <v-tooltip v-model="show" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="white" small>
                              mdi-information-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ filteredDate }}</span> </v-tooltip
                      >: {{ filter.startDate }} - {{ filter.end }}</v-col
                    >
                    <v-col
                      cols="4"
                      lg="4"
                      sm="3"
                      md="4"
                      style="margin-top: -12px"
                      class="text-lg-right font-weight-bold"
                    >
                      FDB
                      <v-tooltip v-model="show" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="white" small>
                              mdi-information-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ filteredBalance }}</span>
                      </v-tooltip>
                      : {{ changingBalance | formatCurrency }}</v-col
                    >
                  </v-row>
                </v-card>
                <v-card
                  height="32px"
                  style="background-color: #005985; font-size: smaller"
                  v-else-if="filter.startDate && !filter.end"
                >
                  <v-row style="color: white">
                    <v-col
                      cols="auto"
                      style="margin-top: -12px"
                      class="mr-auto font-weight-bold ml-2"
                      >FDR
                      <v-tooltip v-model="show" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="white" small>
                              mdi-information-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ filteredDate }}</span> </v-tooltip
                      >: {{ filter.startDate }} -</v-col
                    >
                    <v-col
                      cols="auto"
                      style="margin-top: -12px"
                      class="text-right font-weight-bold text-no-wrap mr-2"
                    >
                      FDB
                      <v-tooltip v-model="show" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="white" small>
                              mdi-information-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ filteredBalance }}</span>
                      </v-tooltip>
                      : {{ changingBalance | formatCurrency }}</v-col
                    >
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12" lg="4" xl="4" md="12" sm="12" xs="12">
                <v-card
                  height="30px"
                  style="background-color: #005985; font-size: smaller"
                  v-if="balance > 0"
                >
                  <v-row style="color: white">
                    <v-col
                      cols="6"
                      lg="5"
                      sm="6"
                      md="5"
                      class="text-no-wrap text-left font-weight-bold ml-2"
                      style="margin: -4px"
                    >
                      Total Balance</v-col
                    >
                    <v-col
                      cols="6"
                      lg="6"
                      sm="5"
                      md="6"
                      style="margin: -4px"
                      class="text-right pa-2 font-weight-bold"
                    >
                      {{ balance | formatCurrency }}</v-col
                    >
                  </v-row>
                </v-card>
                <v-card
                  height="32px"
                  style="background-color: #005985; font-size: smaller"
                  v-else
                >
                  <v-row style="color: white">
                    <v-col
                      cols="auto"
                      style="margin: -4px"
                      class="text-no-wrap mr-auto font-weight-bold ml-2"
                      >Total Balance</v-col
                    >
                    <v-col
                      cols="auto"
                      style="margin: -4px"
                      class="text-right mr-2 font-weight-bold"
                    >
                      {{ balance | formatCurrency }}</v-col
                    >
                  </v-row>
                </v-card>
              </v-col>

              <!-- <v-col cols="8" v-else>
              All  Books </v-col
              > -->
            </v-row>
          </v-col>

          <!-- <v-col
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="py-1"
            v-if="hasFilter('warehouse')"
          >
            <v-datetime-picker clearText label="Datetime" v-model="filter.date">
            </v-datetime-picker>
          </v-col> -->

          <!-- <v-col class="py-2 px-0 clear-lg" v-if="visibleClearBtn">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="clearFilter1"
                  class="icon_small"
                  v-bind="attrs"
                  v-on="on"
                  >mdi-close</v-icon
                >
              </template>
              <span>Clear Filters</span>
            </v-tooltip>
          </v-col> -->
          <v-col cols="12" sm="12" md="6" class="py-1 clear-sm" v-if="false">
            <v-btn
              depressed
              block
              small
              height="30"
              class="ma-auto text-white bg-white w-100 ma-0 filter"
              v-bind="$attrs"
              v-on="on"
              @click="clearFilter1"
              >Clear Filters</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="12"
            class="py-1 p-1"
            v-if="hasFilter('search')"
          >
            <v-row style="padding: 0; margin: 0">
              <v-col cols="8" class="pa-0">
                <SearchAutoComplete
                  v-model="filter.search"
                  :clear="clearFilter"
                ></SearchAutoComplete>
                <!-- <v-text-field
                  hide-details="auto"
                  v-model="filter.search"
                  dense
                  outlined
                  clearable
                  placeholder="Search"
                  append-icon="mdi-magnify"
                >
                </v-text-field> -->
              </v-col>
              <v-col cols="1" class="speech_icon">
                <Speech2Text @speechend="speechEnd" />
              </v-col>
              <v-col cols="2" class="info_icon" style="">
                <v-tooltip v-model="show" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon color="black" small> mdi-information </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ msgs }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
            class="px-3 py-1"
            v-if="columns"
          >
            <TableHeaderFilter
              @updateColumns="updateColumnsTable"
              :columns="columns"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
            class="py-1"
            v-if="clearbutton"
          >
            <v-btn
              depressed
              block
              small
              height="30"
              class="ma-auto text-white bg-white w-100 ma-0 filter"
              v-bind="$attrs"
              v-on="on"
              @click="clearFilter1"
              :clearbutton="clearbutton"
              >Clear</v-btn
            >
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="12"
            class="py-1 p-1"
            v-if="hasFilter('search')"
          >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="hasvisible('visible')">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-row>
          <permission-control permissionName="Product Report Index">
            <v-col
              cols="12"
              sm="12"
              md="8"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('productexport')"
            >
              <ProductExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>
          <permission-control permissionName="Purchase Report Index">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('purchaseexport')"
            >
              <PurchaseExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>

          <permission-control permissionName="PurchaseOrder Report Index">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('purchaseorderexport')"
            >
              <PurchaseOrderExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>
          <permission-control permissionName="PurchaseReturn Report Index">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('purchasereturnexport')"
            >
              <PurchaseReturnExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>
          <permission-control permissionName="Sales Report Index">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('salesexport')"
            >
              <SalesExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>

          <permission-control permissionName="Stocks Report Index">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('outofstockexport')"
            >
              <OutofStockExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>
          <permission-control permissionName="Stocks Report Index">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="12"
              class="px-3 py-1"
              v-if="hasExport('lowstockexport')"
            >
              <LowStockExport @emit="emit" :filter="filter" />
            </v-col>
          </permission-control>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SupplierAutoComplete from '@/components/base/SupplierAutoComplete';
import CustomerTypeAutoComplete from '@/components/base/CustomerTypeAutoComplete.vue';
import SaleTypeAutoComplete from '@/components/base/SaleTypeAutoComplete';
import ExpenseCategoryAutoComplete from '@/components/base/ExpenseCategoryAutoComplete';
import IncomeCategoryAutoComplete from '@/components/base/IncomeCategoryAutoComplete';
import BrandAutoComplete from '@/components/base/BrandAutoComplete';
import CategoryAutoComplete from '@/components/base/CategoryAutoComplete';
import BankAutoComplete from '@/components/base/BankAutoComplete';
import StatusAutoComplete from '@/components/base/StatusAutoComplete';
import PurchaseStatusAutoComplete from '@/components/base/PurchaseStatusAutoComplete';
import TransferStatusAutoComplete from './TransferStatusAutoComplete .vue';
import PurchaseOrderStatusAutoComplete from '@/components/base/PurchaseOrderStatusAutoComplete ';
import PaymentStatusAutoComplete from './PaymentStatusAutoComplete.vue';
import PaymentTypeAutoComplete from './PaymentTypeAutoComplete .vue';
import PaymentFormAutoComplete from './PaymentFormAutoComplete.vue';
import ExpenseFormForAutocomplete from './ExpenseFormForAutocomplete.vue';
import IncomeFormForAutocomplete from './IncomeForAutoComplete.vue';
import ToShopFilterAutocomplete from './ToShopFilterAutocomplete.vue';
import FromShopFilterAutocomplete from './FromShopFilterAutocomplete.vue';
import ChequeStatusAutoComplete from './ChequeStatusAutoComplete.vue';
import ChequeForAutoComplete from './ChequeForAutoComplete.vue';
import SearchAutoComplete from './SearchAutoComplete.vue';
import DateRangeFilter from '@/components/base/DateRangeFilter';
import TotalFilter from '@/components/base/TotalFilter';
import StockCountFilter from '@/components/base/StockCountFilter';
import DamageFilter from '@/components/base/DamageFilter';
import ProductAutoCompleteComponent from '@/components/base/ProductAutoCompleteComponent';
import WareHouseAutoComplete from '@/components/base/WareHouseAutoComplete';
import CustomerAutoComplete from '@/components/base/CustomerAutoComplete';
import BillerAutoComplete from '@/components/base/BillerAutoComplete';
import ShopAutoComplete from '@/components/base/ShopAutoComplete';
import DatePicker from '@/components/base/DatePickerComponent.vue';
import LedgerAutoComplete from '@/components/base/LedgerTypeAutoComplete';
import moment from 'moment';
import Speech2Text from '../../components/base/SpeechToText/SpeechToText';
import { mapState } from 'vuex';

export default {
  components: {
    WareHouseAutoComplete,
    ProductAutoCompleteComponent,
    SupplierAutoComplete,
    BrandAutoComplete,
    CategoryAutoComplete,
    StatusAutoComplete,
    DateRangeFilter,
    TotalFilter,
    DamageFilter,
    StockCountFilter,
    CustomerAutoComplete,
    BillerAutoComplete,
    ShopAutoComplete,
    ExpenseCategoryAutoComplete,
    IncomeCategoryAutoComplete,
    DatePicker,
    LedgerAutoComplete,
    ExpenseFormForAutocomplete,
    SearchAutoComplete,
    BankAutoComplete,
    PurchaseOrderStatusAutoComplete,
    PaymentStatusAutoComplete,
    TransferStatusAutoComplete,
    Speech2Text,
    SaleTypeAutoComplete,
    CustomerTypeAutoComplete,
    PurchaseStatusAutoComplete,
    PaymentTypeAutoComplete,
    PaymentFormAutoComplete,
    ChequeStatusAutoComplete,
    ChequeForAutoComplete,
    IncomeFormForAutocomplete,
    ToShopFilterAutocomplete,
    FromShopFilterAutocomplete,
  },

  props: {
    loading: false,
    output: {
      type: Object,
      default: function () {
        return {};
      },
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      },
    },
    hasDate: {
      type: String,
      default: false,
    },
    clearbutton: {
      type: Array,
      default: function () {
        return [];
      },
    },
    filters: {
      type: Array,
      default: [],
    },
    clear: {
      type: Boolean,
      default: false,
    },
    msgs: {
      type: String,
      default: '',
    },
    filteredDate: {
      type: String,
      default: '',
    },
    filteredBalance: {
      type: String,
      default: '',
    },
    ShopVisible: {
      type: Boolean,
      default: false,
    },
    export: {
      type: Array,
      default: function () {
        return [];
      },
    },
    visible: {
      type: Array,
      default: function () {
        return [];
      },
    },
    products1: {
      type: Array,
      default: function () {
        return [];
      },
    },
    PurchaseList: {
      type: Boolean,
      default: false,
    },
    PurchaseOrderList: {
      type: Boolean,
      default: false,
    },
    stocks: {
      type: Boolean,
      default: false,
    },
    PurchaseReturnList: {
      type: Boolean,
      default: false,
    },
    salesList: {
      type: Boolean,
      default: false,
    },
    balance: {
      type: Number,
      default: function () {
        return {};
      },
    },
    changingBalance: {
      type: Number,
      default: function () {
        return {};
      },
    },
  },
  data: () => ({
    on: {
      // click: console.log,
      contextmenu: console.log,
    },
    inheritAttrs: false,
    feedbackTextArea: '',
    filter: {
      category: '',
      search: '',
      brand: '',
      paymenType: '',
      payment: '',
      type: '',
      startDate: '',
      status: '',
      start: '',
      end: '',
      product: '',
      amount: '',
      damage: '',
      saleType: '',
      paymentStatus: '',
      cash_book_for: '',
      transferStatus: '',
      warehouse: '',
      shop: '',
      bank: '',
      biller: '',
      purchaseStatus: '',
      customerType: '',
      cheqStatus: '',
      cheqFor: '',
      customerGroup: '',
      purchaseOrderStatus: '',
      expenseFor: '',
      incomeFor: '',
      toShop: '',
      fromShop: '',
      expenseCategory: '',
      ledger: '',
      // date: moment(new Date()).format("YYYY-MM-DD"),
    },
    ChecqStatus: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Completed',
        name: 'Completed',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
      {
        id: 'Return',
        name: 'Return',
      },
    ],
    PaymentStatus: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Completed',
        name: 'Completed',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
    ],
    cash_book_for: [
      {
        id: 'Warehouse',
        name: 'Warehouse',
      },
      {
        id: 'Shop',
        name: 'Shop',
      },
    ],
    Payment: [
      {
        id: 'paid',
        name: 'Paid',
      },
      {
        id: 'due',
        name: 'Due',
      },
    ],
    orderStatus: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Received',
        name: 'Received',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
    ],
    paymentFrom: [
      {
        id: 'purchase',
        name: 'purchase',
      },
      {
        id: 'sale',
        name: 'sales',
      },
    ],
    ExpenseFor: [
      {
        id: 'warehouse',
        name: 'Warehouse',
      },
      {
        id: 'shop',
        name: 'Shop',
      },
    ],
    IncomeFor: [
      {
        id: 'warehouse',
        name: 'Warehouse',
      },
      {
        id: 'shop',
        name: 'Shop',
      },
    ],
    PaymentTypes: [
      {
        id: 'Cash',
        name: 'Cash',
      },
      {
        id: 'Card',
        name: 'Card',
      },
      {
        id: 'Cheque',
        name: 'Cheque',
      },
    ],
    // CustomerTypes: [
    //   {
    //     id: "1",
    //     name: "Common",
    //   },
    //   {
    //     id: "2",
    //     name: "Credit",
    //   },
    // ],
    SaleTypes: [
      {
        id: 'cash',
        name: 'Cash',
      },
      {
        id: 'credit',
        name: 'Credit',
      },
    ],
    CustomerGroups: [
      {
        id: '1',
        name: 'Walk-in Customer',
      },
      {
        id: '2',
        name: 'Distributor',
      },
    ],
    clearFilter: false,
    visibleClearBtn: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    updateColumnsTable() {
      this.$emit('updateColumnsTable', true);
    },
    clickedBackButton() {
      this.$emit('updateBackButton', false);
    },
    emit(data) {
      this.$emit('output', data);
    },

    emitFilter() {
      let temFilter = {};
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key] != null && this.filter[key] != '') {
          temFilter[key] = this.filter[key];
        }
      });
      this.$emit('input', temFilter);
    },

    speechEnd({ text }) {
      if (text) {
        this.$store.commit('UPDATE_SEARCH_FILTER_SIZE', text);
        this.filter.search = text + '';
      }
    },

    clearFilter1() {
      if (this.filterDatas.isrouteNewPage == false) {
        this.$store.commit('REMOVE_FILTERDATAS');
      }
      this.clearFilter = !this.clearFilter;
      this.filter = {
        category: '',
        search: '',
        brand: '',
        paymenType: '',
        type: '',
        status: '',
        start: '',
        startDate: '',
        end: '',
        product: '',
        amount: '',
        damage: '',
        paymentStatus: '',
        payment: '',
        transferStatus: '',
        warehouse: '',
        shop: '',
        saleType: '',
        biller: '',
        purchaseStatus: '',
        customerType: '',
        purchaseOrderStatus: '',
        customerGroup: '',
        cheqStatus: '',
        cheqFor: '',
        expenseFor: '',
        incomeFor: '',
        toShop: '',
        fromShop: '',
        expenseCategory: '',
        date: '',
        ledger: '',
      };
    },
    startChange(value) {
      this.filter.start = value;
    },
    startChangeDateBook(value) {
      this.filter.startDate = value;
    },
    clearFilterDates(value) {
      this.filter.start = value;
      this.filter.start = value;
      this.filter.end = value;
    },
    startChangeDate(value) {
      this.filter.date = value;
    },
    endChange(value) {
      this.filter.end = value;
    },
    hasFilter: function (value) {
      return this.filters.indexOf(value) > -1 ? true : false;
    },
    hasExport: function (value) {
      return this.export.indexOf(value) > -1 ? true : false;
    },
    hasvisible: function (value) {
      return this.visible.indexOf(value) > -1 ? true : false;
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.emitFilter();
      },
      deep: true,
    },
  },
  created() {
    if (this.filters.length < 2) {
      this.visibleClearBtn = false;
    } else {
      this.visibleClearBtn = true;
    }
    if (this.ShopVisible) {
      this.filter.shop = 1;
    }

    this.filter.startDate = this.hasDate
      ? moment(new Date()).format('YYYY-MM-DD')
      : '';

    // this.filter.date = new Date();
  },

  computed: {
    ...mapState(['filterDatas']),
  },
};
</script>
<style>
.table-filter {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.clear-sm {
  display: none;
  visibility: hidden;
}

.info_icon {
  margin: 0px;
  margin-top: -15px;
}

.speech_icon {
  margin: 0px;
  margin-top: -15px;
}
@media only screen and (max-width: 1263px) {
  .clear-lg {
    display: none;
    visibility: hidden;
  }
  .clear-sm {
    display: block;
    visibility: visible;
  }
}
</style>
